import { render, staticRenderFns } from "./JoinGroup.vue?vue&type=template&id=1cf718e4&"
import script from "./JoinGroup.vue?vue&type=script&lang=js&"
export * from "./JoinGroup.vue?vue&type=script&lang=js&"
import style0 from "./JoinGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports